// shell-d.jsx — Variant D の共通シェル（HBFooter / HBLayout / HBSubHero）
// variant-d.jsx を先に読み込んで window.HBHeader / hbcp / fontJP 等が公開されている前提。
// サブページ (page-hatena-dx 等) はこのシェルで HBHeader + body + HBFooter を巻き取る。

(function(){
  const { HBHeader, HBLogo, HBChars, HB_NAV, HB_BASE, HB_WANTEDLY,
          hbcp, fontEN, fontENSans, fontJP, fontMono, ease, hbStyles } = window;

  // ---- HBFooter (PC) ----
  // フッターに掲載する法人 (本番 hatenabase.jp の構成と一致):
  //   1. はてなベース株式会社（メイン）       — Service/Information/Recruit/Other 4 列
  //   2. はてなベース税理士法人             — Service/Information/Recruit/Other 4 列
  //   3. はてなベースアドバイザリー株式会社   — Service/Information/Other 3 列
  //   4. はてなベース社会保険労務士事務所     — Service/Information/Other 3 列
  function HBFooter() {
    const COMPANIES = [
      // 1. はてなベース株式会社（メイン）
      {
        name: 'はてなベース株式会社',
        en: 'HatenaBase, Inc.',
        tagline: '成長するスタートアップに "攻めるバックオフィス" を構築する。',
        addr: '東京都新宿区愛住町23-1 woody21 6階',
        mail: 'info@hatenabase.com',
        tel:  '03-4500-2647',
        url:  HB_BASE,
        sections: [
          { h:'Business', jp:'事業内容', items:[
            {t:'バックオフィスBPR', href:`${HB_BASE}/hatena-dx`},
            {t:'会計業務のAX化支援', href:`${HB_BASE}/hatena-account`},
            {t:'経理人材からクラウド会計人材への育成', href:`${HB_BASE}/hatena-content`},
          ]},
          { h:'Information', jp:'情報', items:[
            {t:'支援事例・製品パッケージ',   href:`${HB_BASE}/lp/`},
            {t:'お知らせ',         href:`${HB_BASE}/news`},
            {t:'記事',           href:`${HB_BASE}/blog`},
            {t:'私たちについて',   href:`${HB_BASE}/about-us`},
            {t:'お問い合わせ',     href:`${HB_BASE}/contact`},
            {t:'日程調整',         href:`${HB_BASE}/schedule`},
          ]},
          { h:'Recruit', jp:'採用', items:[
            {t:'採用情報',                  href:`${HB_BASE}/recruit`},
            {t:'一般採用',                  href:HB_WANTEDLY, ext:true},
            {t:'新卒採用・インターン採用',  href:`${HB_WANTEDLY}/newgrad`, ext:true},
          ]},
          { h:'Other', jp:'その他', items:[
            {t:'利用規約',                   href:`${HB_BASE}/terms`},
            {t:'プライバシーポリシー',         href:`${HB_BASE}/privacy-policy`},
            {t:'資料請求',                   href:`${HB_BASE}/document-request`},
            {t:'コンテンツクリエイター向け', href:`${HB_BASE}/for-content-creaters`},
          ]},
        ],
      },
      // 2. はてなベース税理士法人（旧HPはサブドメイン tax.hatenabase.jp で公開済み・旧URL hatenabase.jp/tax-accountant/* は同サブドメインへ転送。フッターリンクは tax.hatenabase.jp へ張替 — Setoguchi #42-4）
      {
        name: 'はてなベース税理士法人',
        en: 'HatenaBase Tax Corporation',
        // 2026-08-30 (#100 再適用 / Issue #118): 事務所サイトは tax.hatenabase.jp で全面改修済みのため
        // リンク無効化（旧 disabled:true）を解除し、URL を footer.php と同じ表に揃える。
        tagline: 'クラウド会計を活用して、質の高い経営判断を。創業期からベンチャー企業、上場企業まで対応する税務の専門家。',
        addr: '東京都新宿区愛住町23-1 woody21 6階',
        mail: 'tamu@hatenabase.com',
        tel:  '',
        url:  `https://tax.hatenabase.jp/`,
        sections: [
          { h:'Service', jp:'料金・サービス', items:[
            {t:'税務顧問',         href:`https://tax.hatenabase.jp/service/tax-advisor/`,       ext:true},
            {t:'融資支援',         href:`https://tax.hatenabase.jp/service/financing-support/`, ext:true},
            {t:'管理会計コンサル', href:`https://tax.hatenabase.jp/service/advisory/`,          ext:true},
            {t:'シミュレーション', href:`https://tax.hatenabase.jp/tools/`,                     ext:true},
          ]},
          { h:'Information', jp:'情報', items:[
            {t:'ブログ',         href:`https://tax.hatenabase.jp/blog/`,     ext:true},
            {t:'私たちについて', href:`https://tax.hatenabase.jp/about-us/`, ext:true},
            {t:'お問い合わせ',   href:`${HB_BASE}/contact/?type=tax-office`},
          ]},
          { h:'Other', jp:'その他', items:[
            {t:'利用規約',  href:`${HB_BASE}/terms`},
          ]},
        ],
      },
      // 3. はてなベースアドバイザリー株式会社（2026-09-29 設立。advisory.hatenabase.jp）
      {
        name: 'はてなベースアドバイザリー株式会社',
        en: 'HatenaBase Advisory',
        tagline: 'IPO支援・価値算定・M&A支援。',
        addr: '東京都新宿区愛住町23-1 woody21 6階',
        mail: '',
        tel:  '',
        url:  'https://advisory.hatenabase.jp/',
        sections: [
          {h:'Service',     jp:'サービスライン', items:[
            {t:'IPO支援',            href:`https://advisory.hatenabase.jp/service/#ipo`,        ext:true},
            {t:'価値算定',           href:`https://advisory.hatenabase.jp/service/#valuation`,  ext:true},
            {t:'M&A支援',            href:`https://advisory.hatenabase.jp/service/#ma`,         ext:true},
            {t:'連結決算・開示支援', href:`https://advisory.hatenabase.jp/service/#disclosure`, ext:true},
          ]},
          {h:'Information', jp:'情報', items:[
            {t:'レポート',       href:`https://advisory.hatenabase.jp/reports/`,  ext:true},
            {t:'私たちについて', href:`https://advisory.hatenabase.jp/about-us/`, ext:true},
            {t:'お問い合わせ',   href:`https://advisory.hatenabase.jp/contact/`,  ext:true},
          ]},
          {h:'Other',       jp:'その他', items:[
            {t:'プライバシーポリシー', href:`https://advisory.hatenabase.jp/privacy-policy/`, ext:true},
          ]},
        ],
      },
      // 4. はてなベース社会保険労務士事務所（sr.hatenabase.jp）
      {
        name: 'はてなベース社会保険労務士事務所',
        en: 'HatenaBase Labor Office',
        tagline: '給与計算・社会保険・労働保険。',
        addr: '東京都新宿区愛住町23-1 woody21 6階',
        mail: '',
        tel:  '',
        url:  'https://sr.hatenabase.jp/',
        sections: [
          {h:'Service',     jp:'業務内容', items:[
            {t:'労働社会保険業務', href:`https://sr.hatenabase.jp/service/labor-insurance/`, ext:true},
            {t:'給与計算業務',     href:`https://sr.hatenabase.jp/service/payroll/`,         ext:true},
            {t:'アドバイザリー業務', href:`https://sr.hatenabase.jp/service/advisory/`,      ext:true},
            {t:'労務DX支援業務',   href:`https://sr.hatenabase.jp/service/hr-dx/`,           ext:true},
          ]},
          {h:'Information', jp:'情報', items:[
            {t:'私たちについて', href:`https://sr.hatenabase.jp/about-us/`, ext:true},
            {t:'お問い合わせ',   href:`https://sr.hatenabase.jp/contact/`,  ext:true},
          ]},
          {h:'Other',       jp:'その他', items:[
            {t:'プライバシーポリシー', href:`https://sr.hatenabase.jp/privacy-policy/`, ext:true},
          ]},
        ],
      },
    ];

    return (
      <footer style={{padding:'88px 32px 96px', background:hbcp.ink, color:'#fff', position:'relative', overflow:'hidden'}}>
        <svg style={{position:'absolute', bottom:-200, right:-200, width:560, height:560, opacity:.15, pointerEvents:'none'}} viewBox="0 0 560 560">
          {[...Array(8)].map((_,i)=>(<circle key={i} cx="280" cy="280" r={40+i*30} fill="none" stroke={hbcp.blueLight} strokeOpacity=".4" strokeWidth=".7"/>))}
        </svg>
        <div style={{position:'relative', maxWidth:1280, margin:'0 auto'}}>

          {/* 巨大ロゴ＋GO TO TOP */}
          <div style={{padding:'24px 0 40px', borderBottom:'1px solid rgba(255,255,255,.15)', display:'flex', alignItems:'flex-end', justifyContent:'space-between', flexWrap:'wrap', gap:24}}>
            <div>
              {/* Issue #81: 「Hatenabase,Group.」テキスト位置に はてなベース ロゴを配置 */}
              <HBLogo height={56} light/>
              <div style={{fontFamily:fontEN, fontWeight:300, fontSize:22, color:hbcp.blueLight, marginTop:16, letterSpacing:'.02em'}}>
                Backoffice, redesigned.
              </div>
            </div>
            <a href="#top" onClick={(e)=>{ e.preventDefault(); window.scrollTo({top:0, behavior:'smooth'}); }}
               style={{display:'inline-flex', alignItems:'center', gap:10, fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', color:'rgba(255,255,255,.6)', textDecoration:'none', padding:'14px 18px', border:'1px solid rgba(255,255,255,.25)'}}>
              GO TO TOP <span style={{fontFamily:fontEN, fontSize:14}}>↑</span>
            </a>
          </div>

          {/* 会社別ブロック（株式会社・税理士法人・アドバイザリー・社労士事務所） */}
          {COMPANIES.map( (co, idx) => (
            <div key={co.name} className="hb-footer-co" style={{padding:'48px 0', borderBottom:'1px solid rgba(255,255,255,.15)'}}>
              <div style={{display:'grid', gridTemplateColumns: co.sections.length > 0 ? '1.6fr 1fr 1fr 1fr 1fr' : '1fr', gap:40, alignItems:'flex-start'}}>
                {/* 会社情報カラム */}
                <div>
                  <div style={{fontFamily:fontENSans, fontSize:10, fontWeight:500, letterSpacing:'.32em', color:hbcp.blueLight, marginBottom:14, textTransform:'uppercase'}}>{co.en}</div>
                  <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, lineHeight:1.45, margin:'0 0 14px', color:'#fff'}}>
                    {(co.url && !co.disabled) ? <a href={co.url} style={{color:'inherit', textDecoration:'none'}}>{co.name.replace('はてなベース','はてなベース\u200b').split('\u200b').map(t => <span key={t} style={{display:'inline-block'}}>{t}</span>)}</a> : co.name}
                  </h3>
                  <p style={{fontSize:12.5, lineHeight:1.95, color:'rgba(255,255,255,.7)', margin:'0 0 18px', maxWidth:320}}>{co.tagline}</p>
                  <div style={{fontFamily:fontMono, fontSize:11, fontWeight:700, color:'rgba(255,255,255,.85)', lineHeight:1.95}}>
                    {co.addr && (<>{co.addr}<br/></>)}
                    {co.tel  && (<>TEL  {co.tel}<br/></>)}
                    {co.mail && (<>MAIL {co.mail}</>)}
                  </div>
                  {false && idx === 0 && ( /* X/note(個人アカ)非表示 (Setoguchi #42-4) */
                    <div style={{display:'flex', gap:8, marginTop:22}}>
                      <a href="https://x.com/hs_hatenabase" target="_blank" rel="noopener" aria-label="X" style={{width:36, height:36, borderRadius:'50%', border:'1px solid rgba(255,255,255,.25)', display:'grid', placeItems:'center'}}>
                        <img src={(window.HB_ASSETS||'')+"images/x_logo.svg"} alt="" style={{width:13, height:13}}/>
                      </a>
                      <a href="https://note.com/hatenabase" target="_blank" rel="noopener" aria-label="note" style={{width:36, height:36, borderRadius:'50%', border:'1px solid rgba(255,255,255,.25)', display:'grid', placeItems:'center'}}>
                        <img src={(window.HB_ASSETS||'')+"images/note_icon.svg"} alt="" style={{width:13, height:13}}/>
                      </a>
                    </div>
                  )}
                </div>

                {/* リンクセクション (4 列) */}
                {co.sections.map( s => (
                  <div key={s.h}>
                    <div style={{fontFamily:fontENSans, fontSize:10, fontWeight:500, letterSpacing:'.32em', color:hbcp.blueLight, marginBottom:12, textTransform:'uppercase'}}>{s.h}</div>
                    <div style={{fontFamily:fontJP, fontSize:11, color:'rgba(255,255,255,.55)', marginBottom:14}}>{s.jp}</div>
                    {s.items.map( it => (
                      <a key={it.t} href={it.href} target={it.ext?'_blank':'_self'} rel="noopener"
                            style={{display:'block', color:'#fff', textDecoration:'none', fontSize:12.5, padding:'6px 0', opacity:.85}}>{it.t}</a>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* BOTTOM */}
          <div style={{display:'flex', flexWrap:'wrap', gap:18, justifyContent:'space-between', paddingTop:28, fontFamily:fontMono, fontSize:10.5, color:'rgba(255,255,255,.5)'}}>
            <div>共通所在地：東京都新宿区愛住町23-1 woody21 6階</div>
            <div>Copyright © {(y => y === 2025 ? '2025' : '2025–' + y)(new Date().getFullYear())} HatenaBase Inc.</div>
            <div style={{display:'flex', gap:24, flexWrap:'wrap'}}>
              <a href={`${HB_BASE}/terms`} style={{color:'inherit', textDecoration:'none'}}>利用規約</a>
              <a href={`${HB_BASE}/privacy-policy`} style={{color:'inherit', textDecoration:'none'}}>プライバシーポリシー</a>
              <a href={`${HB_BASE}/document-request`} style={{color:'inherit', textDecoration:'none'}}>資料請求</a>
              <a href={`${HB_BASE}/contact`} style={{color:'inherit', textDecoration:'none'}}>お問い合わせ</a>
            </div>
          </div>
        </div>

        {/* レスポンシブ: モバイルで 5 列を 2 列に折りたたむ */}
        <style>{`
          @media (max-width: 880px) {
            .hb-footer-co > div { grid-template-columns: 1fr 1fr !important; gap: 24px !important; }
            .hb-footer-co > div > div:first-child { grid-column: 1 / -1; }
          }
        `}</style>
      </footer>
    );
  }

  // ---- HBSubHero: サブページ用の共通ヒーロー ----
  // crumb: パンくず文字列 (例: "Service / Hatena, DX.")
  // en:   英語ラベル (例: "Hatena, DX.")
  // jp:   メインタイトル日本語 (例: "DX・システム開発")
  // tag:  italic 一行 (例: "Designing the new operating system of business.")
  // lead: 段落本文
  function HBSubHero({ crumb, en, jp, tag, lead, bgImage }) {
    const heroBase = {position:'relative', padding:'72px 32px 64px', overflow:'hidden', borderBottom:`1px solid ${hbcp.line}`};
    const heroStyle = bgImage
      ? {...heroBase, backgroundImage:`linear-gradient(rgba(255,255,255,.84), rgba(255,255,255,.9)), url(${bgImage})`, backgroundSize:'cover', backgroundPosition:'center'}
      : {...heroBase, background:hbcp.white};
    return (
      <section style={heroStyle}>
        <svg style={{position:'absolute', top:-40, right:-220, width:520, height:520, opacity:.4, pointerEvents:'none'}} viewBox="0 0 520 520">
          {[...Array(9)].map((_,i)=>(<circle key={i} cx="260" cy="260" r={40+i*24} fill="none" stroke={hbcp.blue} strokeOpacity=".15" strokeWidth=".7"/>))}
        </svg>
        <div style={{position:'relative', maxWidth:1280, margin:'0 auto'}}>
          {crumb && (
            <div style={{fontFamily:fontMono, fontSize:11, letterSpacing:'.06em', color:hbcp.inkLight, marginBottom:28}}>
              {crumb}
            </div>
          )}
          {en && (
            <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', color:hbcp.blue, marginBottom:18, display:'flex', alignItems:'center', gap:14}}>
              <span style={{display:'inline-block', width:8, height:8, borderRadius:'50%', background:hbcp.blue}}/>
              {en.toUpperCase()}
            </div>
          )}
          <h1 style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(36px, 5.5vw, 72px)', lineHeight:1.4, letterSpacing:'.04em', margin:0}}>
            {jp}
          </h1>
          {tag && (
            <div style={{marginTop:14, fontFamily:fontEN, fontWeight:300, fontSize:'clamp(16px, 1.6vw, 22px)', color:hbcp.blue, lineHeight:1.3}}>
              {tag}
            </div>
          )}
          {lead && (
            <p style={{fontSize:16, lineHeight:1.9, color:hbcp.inkSoft, margin:'28px 0 0', maxWidth:680}}>{lead}</p>
          )}
        </div>
      </section>
    );
  }

  // ---- HBLayout: HBHeader + 子ノード + HBFooter ----
  function HBLayout({ children }) {
    const rootRef = React.useRef(null);
    React.useEffect(() => {
      // 共通 reveal 観測
      const root = rootRef.current; if (!root) return;
      const reveals = root.querySelectorAll('.hb-chars, .hb-up');
      const io = new IntersectionObserver(es => {
        es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
      reveals.forEach(el => {
        io.observe(el);
        if (el.closest('.hb-hero, .hb-subhero')) {
          requestAnimationFrame(() => el.classList.add('is-in'));
        }
      });
      return () => io.disconnect();
    }, []);

    return (
      <div ref={rootRef} className="ab-scroll hb-root" style={{
        width:'100%', minHeight:'100vh', overflowX:'hidden', overflowY:'auto', position:'relative',
        background:hbcp.white, color:hbcp.ink, fontFamily:fontJP, letterSpacing:'.02em',
        ['--hb-blue']: hbcp.blue,
        ['--hb-blue-light']: hbcp.blueLight,
        ['--hb-blue-ghost']: hbcp.blueGhost,
        ['--hb-ink']: hbcp.ink,
        ['--hb-paper']: hbcp.paper,
      }}>
        <style>{hbStyles}</style>
        <HBHeader/>
        {children}
        <HBFooter/>
      </div>
    );
  }

  Object.assign(window, { HBFooter, HBSubHero, HBLayout });
})();
